import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=b738d9bc&"
import script from "./Type.vue?vue&type=script&lang=ts&"
export * from "./Type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports